import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, concatMap, map, switchMap, filter } from "rxjs/operators";

import { CustomerConsistencyService } from "../customer-consistency/customer-consistency.service";
import { FabricLobbyConfigService } from "../fabricLobbyConfigService/fabricLobbyConfigService";

import { GAME_COLLECTION_ACTION_TYPE, GameCollectionAction } from "./game-collection.action";
import { GAME_COLLECTION_CONTEXT } from "./game-collection.const";
import { GameCollectionService } from "./game-collection.service";

@Injectable()
export class GameCollectionEffect {
	gameCollections$ = createEffect(() =>
		this.actions$.pipe(
			ofType(GAME_COLLECTION_ACTION_TYPE.getAll),
			filter(() => this.fabricLobbyConfigService.blockSSRForClients()),
			switchMap(() =>
				this.customerConsistencyService.consistentCustomer$.pipe(
					switchMap((customer) =>
						this.service.getAll(customer).pipe(
							map((response) => this.action.getAllSuccess(response)),
							catchError((error: AppError) => of(this.action.getAllFail(error)))
						)
					)
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$(
				{
					[GAME_COLLECTION_ACTION_TYPE.getAllFail]: GAME_COLLECTION_CONTEXT.getAll,
				},
				MessageScopeType.Global,
				MessageType.Error
			),
			this.messageService.mapClearByContext$({
				[GAME_COLLECTION_ACTION_TYPE.getAll]: GAME_COLLECTION_ACTION_TYPE.getAll,
			})
		)
	);

	getGameCollectionById$ = createEffect(() =>
		this.actions$.pipe(
			ofType<ActionWithPayload<string>>(GAME_COLLECTION_ACTION_TYPE.getById),
			filter(() => this.fabricLobbyConfigService.blockSSRForClients()),
			concatMap(({ payload }) =>
				this.service.getById(payload).pipe(
					map((response) => this.action.getByIdSuccess(response)),
					catchError((error: AppError) => of(this.action.getByIdFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private action: GameCollectionAction,
		private service: GameCollectionService,
		private messageService: MessageService,
		private customerConsistencyService: CustomerConsistencyService,
		private fabricLobbyConfigService: FabricLobbyConfigService
	) {}
}
